<template>
  <InputGroup
    v-bind="inputAttrs"
  >
    <template
      v-if="showLeft"
      #left
    >
      <NewBsBox
        :bs="{ 'cmp.inputGroup': 'addonBefore' }"
      >
        <UnitCell
          :disabled="disabled || null"
          :readonly="readonly"
          :bs="cellBs"
          :unit-enums="leftOptions"
          :current-uit="left"
          :on-select-unit="selectLeft"
        />
      </NewBsBox>
    </template>
    <template
      v-if="showRight"
      #right
    >
      <NewBsBox
        :bs="{ 'cmp.inputGroup': 'addonAfter' }"
      >
        <UnitCell
          :disabled="disabled || null"
          :readonly="readonly"
          :bs="cellBs"
          :unit-enums="rightOptions"
          :current-uit="right"
          :on-select-unit="selectRight"
        />

      </NewBsBox>
    </template>
  </InputGroup>
</template>

<script lang="ts">
  import {
    defineComponent, PropType, computed,
  } from 'vue'
  import { isNil } from 'lodash'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import InputGroup from '../InputGroup/InputGroup.vue'
  import UnitCell from './UnitCell.vue'
  import { BeerStyleObj } from '../../../core'

  /**
   * 带单位的输入，可以是左边，也可以是右边，单位格可以下拉选择
   * @see 继承InputGroup #InputGroup
   */
  export default defineComponent({
    name: 'InputWithUnit',
    components: {
      InputGroup,
      UnitCell,
      NewBsBox,
    },
    props: {
      /**
       * @ignore
       *  容器 Bs，传递给 InputGroup
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       * 单位格的 BS
       */
      cellBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 控制的值
       */
      modelValue: [String, Number],
      /**
       * 左边的值
       */
      left: {
        type: [String, Number],
      },
      /**
       * 左边的选项
       */
      right: {
        type: [String, Number],
      },
      /**
       * 左边选项 string 列表
       */
      leftOptions: {
        type: Array,
        default: () => ([]),
      },
      /**
       * 右边选项 string 列表
       */
      rightOptions: {
        type: Array,
        default: () => ([]),
      },
      /**
       * @ignore
       * 是否只读显示
       */
      readonly: {
        type: Boolean,
        default: false,
      },
      /**
       * 是否禁止
       */
      disabled: {
        type: Boolean,
        default: false,
      },
      /**
       * @ignore
       * placeholder 的快捷 props
       */
      placeholder: {
        type: String,
        default: '请输入',
      },
    },
    emits: {
      /**
       * 左边单位更新, v-model:left
       */
      'update:left': null,
      /**
       * 右边单位更新 v-model:right
       */
      'update:right': null,
      /**
       * 自身更新 v-model
       */
      'update:modelValue': null,
    },
    setup(props, { emit, attrs }) {
      const showLeft = computed(() => props.leftOptions.length > 0)
      const showRight = computed(() => props.rightOptions.length > 0)

      const handleInput = (e: KeyboardEvent) => {
        emit('update:modelValue', (e.target as HTMLInputElement).value)
      }
      const inputAttrs = computed(() => {
        const attr: any = {
          bs: props.bs,
          readonly: props.readonly,
          placeholder: props.placeholder,
          onInput: handleInput,
          ...attrs,
        }
        if (props.disabled) {
          attr.disabled = true
        }
        if (!isNil(props.modelValue)) {
          attr.value = props.modelValue
        }
        return attr
      })

      return {
        showLeft,
        showRight,
        inputAttrs,
        selectRight: (val: string) => {
          emit('update:right', val)
        },
        selectLeft: (val: string) => {
          emit('update:left', val)
        },
      }
    },
  })
</script>
